import Cookies from 'js-cookie'
import * as types from '../mutation-types'
import axios from 'axios'

// state
export const state = {
  table: null,
  tables: null,
  tableList: null,
}

// getters
export const getters = {
  tableList() {
    return state.tableList;
  },
  tableData() {
    return state.table;
  },
  relatedData() {
    return state.tables;
  },
}

// mutations
export const mutations = {
  setTableData(state, resp) {
    if (Array.isArray(resp.data)) {
      state.table = resp.data[0];
      state.tables = resp.data.slice(1, resp.data.length)
    } else {
      state.table = resp.data
    }
  },
  setTableList(state, resp) {
    state.tableList = resp.data
  },
  getExportData(state, resp) {
    state.export = resp.data;
  }
}

// actions
export const actions = {
  getTableList({ commit }, request) {
    axios.get('/api/admin/table/list', { params: request.data })
      .then((response) => {
        commit('setTableList', response)
        request.stateCallback("success")
      })
      .catch((error) => request.stateCallback("error"));
  },
  getTableRecordData({ commit }, request) {
    axios.get('/api/admin/table/record', { params: request.data })
      .then((response) => {
        commit('setTableData', response)
        request.stateCallback("success")
      })
      .catch((error) => request.stateCallback("error"));
  },
  getTableData({ commit }, request) {
    axios.get('/api/admin/table', { params: request.data })
      .then((response) => commit('setTableData', response))
      .catch((error) => request.stateCallback("error"));
  },
  saveTableData({ commit }, request) {
    axios.post('/api/admin/table', request.data)
      .then((response) => commit('setTableData', response))
      .catch((error) => request.stateCallback("error"));
  },
  deleteTableData({ commit }, request) {
    axios.delete('/api/admin/table', request.data)
      .then((response) => commit('setTableData', response))
      .catch((error) => request.stateCallback("error"));
  }
}
